export const constants = {
  targetZone: {
    title: "Target Zone",
    addButtonTitle: "Add Target Zone",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No target zones added yet.",
  },
  details: {
    title: "Target Zone Details",
    backButton: " Back to Target Zones",
  },
};
